// src/hooks/usePrefillUserData.ts

import { useMemo } from 'react';
import useVerifyUser from '@/hooks/profile/useVerifyUser';
import { convertFarsiToEnglishNumerals } from '@/utils/numberConversionUtils';

/**
 * A reusable hook to get pre-filled user data (name, email, phone)
 * for forms, including special business logic for skipping certain data.
 */
export const usePrefillUserData = () => {
    const { isLoggedInGlobal, user } = useVerifyUser();

    const prefilledData = useMemo(() => {
        // Default empty values if user is not available
        if (!isLoggedInGlobal || !user) {
            return {
                prefilledName: '',
                prefilledEmail: '',
                prefilledPhone: '',
            };
        }

        const firstName = (user.firstName ?? '').trim();
        const email = (user.email ?? '').trim();
        const mobile = (user.mobile ?? '').trim();

        // Business logic to skip prefilling certain default names/emails
        const blockName = firstName.startsWith('کاربر با موبایل');
        const blockEmail = email.startsWith('erp_client');

        const prefilledName = blockName
            ? '' // Don't prefill name if it's the default mobile user
            : [firstName].filter(Boolean).join(' ');

        const prefilledEmail = blockEmail ? '' : email;
        const prefilledPhone = mobile ? convertFarsiToEnglishNumerals(mobile) : '';

        return { prefilledName, prefilledEmail, prefilledPhone };
    }, [isLoggedInGlobal, user]);

    return prefilledData;
};
